import { Separator } from "../separator";

export const EditorToolbarSeparator = () => <Separator orientation="vertical" className="h-6 mx-1" />;
